import { useContext, useEffect, useState } from "react";
import { CustomFormContext } from "../../CustomForm";
import { prepareContent } from "../../helpers";
import dayjs from "dayjs";

interface HiddenValueCalculatorProps {
  nonForm?: boolean;
  alias: string;
  value1: string | undefined;
  value2: string | undefined;
}

const HiddenValueCalculator = ({
  nonForm = false,
  alias,
  value1,
  value2,
}: HiddenValueCalculatorProps) => {
  const { setDataDispatch, dataIsSet, errorsAreSet, fieldValue, tempData } =
    useContext(CustomFormContext);

  const [value, setValue] = useState<number | null>(null);
  useEffect(() => {
    if (!dataIsSet || !errorsAreSet) {
      return;
    }

    if (!value1 || !value2) {
      return;
    }

    const startDate = fieldValue(value1);
    const endDate = fieldValue(value2);

    if (!endDate) {
      setValue(1);
      return;
    }

    if (!startDate || !endDate) {
      return;
    }
    const start = dayjs(startDate);
    const end = dayjs(endDate);
    const diff = end.diff(start, "days") + 1;
    setValue(diff);
  }, [dataIsSet, errorsAreSet, tempData]);

  const handleSave = () => {
    const data = prepareContent(value, alias, nonForm);
    setDataDispatch({
      type: "UPDATE_CONTENT",
      payload: { ...data },
    });
  };

  useEffect(() => {
    handleSave();
  }, [value]);

  return <div />;
};

HiddenValueCalculator.fieldType = "HiddenValueCalculator";

export default HiddenValueCalculator;
